import { cr } from "fire-wind-water";
import Select from "ant-design-vue/lib/select"; // 加载 JS
import "ant-design-vue/lib/select/style/css"; // 加载 CSS
import Cascader from "ant-design-vue/lib/cascader"; // 加载 JS
import "ant-design-vue/lib/cascader/style/css"; // 加载 CSS
import Icon from "ant-design-vue/lib/icon";
import "ant-design-vue/lib/icon/style/css"; // 加载 CSS
import Vue from "vue";
import common from "./common";
Vue.use(Select)
  .use(Cascader)
  .use(Icon);
const selectMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      fieldNames: {
        label: "optionValue",
        value: "optionId",
        children: "children"
      },
      fieldObj: {},
      dicResult: [],
      otherOptionIds: [],
      selectIsOpen: false,
      inputFocus: false,
      moved: false,
      optionId: "" //当前选中的option
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请选择";
    }
    if (this.field.listOptionType == "DICT") {
      this.fieldObj = new window.$sk.Cascader(this.field);
      if (this.fieldObj.isCascade === 0){
        this.fieldObj = new window.$sk.Select(this.field);
      }else{
        cr.each(this.fieldObj.cascaderList, m => {
          cr.each(m.children, i => {
            if (!i.children.length) {
              i.children = undefined;
            }
          });
        });
      }
    } else {
      this.fieldObj = new window.$sk.Select(this.field);
    }
    cr.each(this.fieldObj.listOptions, m => {
      if (m.otherisFillIn == 1) {
        this.otherOptionIds.push(m.optionId);
      }
      if (m.isDefault == 1) {
        this.optionId = m.optionId;
        this.fieldObj.setValue(m.optionId);
      }
    });

    //回填数据
    if (!this.fieldValue) {
      return;
    }
    if (this.fieldObj.isCascade === 1) {
      let currentItem = [];
      cr.each(this.fieldValue, (m, i) => {
        const item = this.fieldObj.listOriginal[i].filter(d => {
          return d.optionValue === m;
        });
        currentItem = [...currentItem, ...item];
      });
      this.dicResult = currentItem;
      this.fieldObj.setValue(currentItem);
    } else {
      cr.each(this.fieldObj.listOptions, m => {
        if (this.fieldValue == m.optionValue) {
          if (this.field.listOptionType == "DICT") {
            this.dicResult = m;
            this.fieldObj.setValue(this.dicResult.optionId);
          } else {
            this.optionId = m.optionId;
            this.fieldObj.setValue(this.optionId);
          }
        }
      });
    }
  },
  methods: {
    updateDicList(obj) {
      this.dicLists[obj.index] = obj.dictValues;
    },
    dicListChange(value, selectedOptions) {
      this.dicResult = selectedOptions;
      this.fieldObj.setValue(this.dicResult);
      this.moved = false;
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value:value[value.length-1],
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    inputBlur(e, o) {
      this.fieldObj.setOtherValue(o.optionId, e.target.value);
      this.inputFocus = false;
      this.selectIsOpen = false;
    },
    handleFocus() {
      setTimeout(() => {
        this.selectIsOpen = true;
      }, 100);
      this.moved = true;
    },
    handleBlur() {
      if (!this.inputFocus) {
        this.selectIsOpen = false;
        this.moved = false;
      }
    },
    handleChange(val) {
      // if (this.otherOptionIds.length) {
      this.inputFocus = false;
      this.$refs.selectref.blur();
      this.moved = false;
      // }
      this.dicResult = val
        ? [this.fieldObj.listOptions.find(o => o.optionId == val)]
        : [];
      this.optionId = val;
      if (this.field.listOptionType == "DICT") {
        this.fieldObj.setValue(this.dicResult[0].optionId);
      } else {
        this.fieldObj.setValue(this.optionId);
      }
      // Vue.set(this.fieldObj,"value",this.optionId);
      let selectedValue ="";
      //针对客户管理里面的独立选项 fieldLevel 1是全局 2是模块 4 自定义的 3实例下的
      if((this.field.fieldLevel==1||this.field.fieldLevel==2||this.field.fieldLevel==3)&&this.field.listOptionType=='CUSTOM'){
        this.fieldObj.listOptions.filter(b => {
          if(b.checked){
            selectedValue =b.optionValue;
          }
        });
      }
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value:selectedValue?selectedValue:val,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    inputClick(e, o) {
      let index = this.otherOptionIds.findIndex(id => id == o);
      this.$refs.inputref[index].focus();
      this.inputFocus = true;
      // e.stopPropagation();

      this.fieldObj.setOtherValue(o, e.target.value);
    },
    textChange(e, o) {
      this.fieldObj.setOtherValue(o, e.target.value);
    }
  }
};
export default selectMixin;
